import { Injectable } from '@angular/core';

import { ReportsList } from '../models/reports-list';
import { ReportingService } from '../../../api/reporting.service';
import { FeeSplitsReportService } from './fee-splits-report.service';
import { LeasePropertyCustomerReportService } from './lease-property-customer-report.service';
import { DealFileChecklistHongkongReportService } from './deal-file-checklist-hongkong-report.service';
import { SaleConsultingPropertyCustomerReportService } from './sale-consulting-property-customer-report.service';
import { SaleDsfConsultingReportService } from './sale-dsf-consulting-report.service';
import { DealFileChecklistChinaReportService } from './deal-file-checklist-china-report.service';
import { DisbursementsService } from './disbursements.service';
import { DsfEngagementCustomerDataService } from './dsf-engagement-customer-data.service';
import { DealFileChecklistAustraliaReportService } from './deal-file-checklist-australia-report.service';
import { DealFileChecklistIndiaReportService } from './deal-file-checklist-india-report.service';
import { DealFileChecklistNewZealandReportService } from './deal-file-checklist-newzealand-report.service';
import { DealFileChecklistSingaporeReportService } from './deal-file-checklist-singapore-report.service';
import { LeaseRentReviewReportService } from './lease-rent-review-report.service'
import { LeaseIncentivesReportService } from './lease-incentives-report.service';
import { FeeInfluencerReportService } from './fee-influencer-report.service';
import { DealFileChecklistTaiwanReportService } from './deal-file-checklist-taiwan-report.service';
import { DealFileChecklistJapanReportService } from './deal-file-checklist-japan-report.service';
import { LeaseTenantPriorLocationService } from './lease-tenant-prior-location.service';
import { LeaseFeeCalculationReportService } from './lease-fee-calculation-report.service';
import { YTDSummaryReportService } from './ytd-summary.service';
import { YTDSummaryFinanceReportService } from './ytd-summary-finance-report.service';
import { YTDSummaryCompanyIncomeReportService } from './ytd-summary-company-income-report.service';
import { ValuationsReportService } from './valuations-engagement-customer.service';
import { ValuationSummaryReportService } from './valuation-summary-report.service';
import { DataObject } from '../../../interfaces/data-objects';
import { Countries } from './../../../utils/countries-enum';
import { ValuationPropertyCustomerReportService } from './valuation-property-customer-report.service';

@Injectable({
  providedIn: 'root',
})
export class ReportMappingService {
  headers: DataObject[] = [];
  middle = {
    alignment: {
      wrapText: true,
      vertical: 'middle',
      horizontal: 'center',
    },
  };
  left = {
    alignment: {
      wrapText: true,
      vertical: 'middle',
      horizontal: 'left',
    },
  };
  right = {
    alignment: {
      wrapText: true,
      vertical: 'middle',
      horizontal: 'right',
    },
  };

  constructor(
    private reportingService: ReportingService,
    private feeSplitsReportService: FeeSplitsReportService,
    private leasePropertyCustomerReportService: LeasePropertyCustomerReportService,
    private dealFileChecklistHongkongReportService: DealFileChecklistHongkongReportService,
    private saleConsultingPropertyCustomerReportService: SaleConsultingPropertyCustomerReportService,
    private saleDSFConsultingReportService: SaleDsfConsultingReportService,
    private dealFileChecklistChinaReportService: DealFileChecklistChinaReportService,
    private disbursementsservice: DisbursementsService,
    private dsfengagementcustomerdataService: DsfEngagementCustomerDataService,
    private dealFileChecklistAustraliaReportService: DealFileChecklistAustraliaReportService,
    private dealFileChecklistIndiaReportService: DealFileChecklistIndiaReportService,
    private dealFileChecklistNewZealandReportService: DealFileChecklistNewZealandReportService,
    private dealFileChecklistSingaporeReportService: DealFileChecklistSingaporeReportService,
    private dealFileChecklistJapanReportService: DealFileChecklistJapanReportService,
    private leaseRentReviewReportService: LeaseRentReviewReportService,
    private leaseIncentivesReportService: LeaseIncentivesReportService,
    private feeInfluencerReportService: FeeInfluencerReportService,
    private dealFileChecklistTaiwanReportService: DealFileChecklistTaiwanReportService,
    private leaseTenantPriorLocationService: LeaseTenantPriorLocationService,
    private leaseFeeCalculationReportService: LeaseFeeCalculationReportService,
    private ytdSummaryReportsService: YTDSummaryReportService,
    private ytdSummaryFinanceReportService: YTDSummaryFinanceReportService,
    private ytdSummaryCompanyIncomeReportService: YTDSummaryCompanyIncomeReportService,
    private valuationsReportService: ValuationsReportService,
    private valuationSummaryReportService: ValuationSummaryReportService,
    private valuationPropertyCustomerReportService: ValuationPropertyCustomerReportService,
  ) { }

  getAllFilters(someSelected: any, allSelected: any, labelOrValue?: any) {
    if (allSelected) {
      return 'all';
    } else {
      if (labelOrValue === 'label') {
        return (someSelected?.map((listitem: any) => { return listitem.label; })) || null;
      } else {
        return (someSelected?.map((listitem: any) => { return listitem.value; })) || null;
      }
    }
  }

  getFiltersAsParams(labelOrValue: null | string = null): any {
    const filters = JSON.parse(window.localStorage.getItem('reportfilters') ?? '');
    let transaction_types_list: any, functional_unit_list: any, managing_office_list: any, producer_list: any;

    transaction_types_list = this.getAllFilters(filters.transaction_types_list, filters.all_transactions, labelOrValue);
    functional_unit_list = this.getAllFilters(filters.functional_unit_list, filters.all_functionals, labelOrValue);
    managing_office_list = this.getAllFilters(filters.managing_office_list, filters.all_managings, labelOrValue);
    producer_list = this.getAllFilters(filters.producer_list, filters.all_producers, labelOrValue);

    return { transaction_types_list, functional_unit_list, managing_office_list, producer_list };
  }

  map(id: number | null, transactionSummaryData: any) {
    switch (id) {
      case ReportsList.DEAL_FILE_CHECKLIST:
        const country = window.localStorage.getItem('country');
        switch (country) {
          case Countries.Australia:
            this.headers = this.dealFileChecklistAustraliaReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.India:
            this.headers = this.dealFileChecklistIndiaReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.NewZealand:
            this.headers = this.dealFileChecklistNewZealandReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.Hongkong:
            /* this needed while downloading reports as Excel format */
            this.headers = this.dealFileChecklistHongkongReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.Singapore:
          case Countries.Indonesia:
            this.headers = this.dealFileChecklistSingaporeReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.Thailand:
          case Countries.Philippines:
          case Countries.Vietnam:
          case Countries.Korea:
            break;
          case Countries.Taiwan:
            this.headers = this.dealFileChecklistTaiwanReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.Japan:
            this.headers = this.dealFileChecklistJapanReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
          case Countries.China:
            this.headers = this.dealFileChecklistChinaReportService.getHeaders({
              'middle': this.middle, 'left': this.left, 'right': this.right
            });
            break;
        }
        break;
      case ReportsList.DSF_ENGAGEMENT_CUSTOMER_DATA:
        /* this needed while downloading reports as Excel format */
        this.headers = this.dsfengagementcustomerdataService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.EXPENSE_DISBURSEMENTS:
        this.headers = this.disbursementsservice.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.FEE_INFLUENCER:
        this.headers = this.feeInfluencerReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.FEE_SPLITS:
        /* this needed while downloading reports as Excel format */
        this.headers = this.feeSplitsReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.LEASE_FEE_CALCULATION:
        this.headers = this.leaseFeeCalculationReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.LEASE_INCENTIVES:
        this.headers = this.leaseIncentivesReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.LEASE_PROPERTY_CUSTOMER_DATA:
        this.headers = this.leasePropertyCustomerReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.LEASE_RENT_REVIEW:
        this.headers = this.leaseRentReviewReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.LEASE_TENANT_PRIOR_LOCATION:
        this.headers = this.leaseTenantPriorLocationService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.SALE_CONSULTING_PROPERTY_CUSTOMER_DATA:
        this.headers = this.saleConsultingPropertyCustomerReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.SALE_DSF_CONSULTING_FEE_CALCULATION:
        this.headers = this.saleDSFConsultingReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.YTD_SUMMARY:
        this.headers = this.ytdSummaryReportsService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.YTD_SUMMARY_FINANCE:
        this.headers = this.ytdSummaryFinanceReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.YTD_SUMMARY_COMPANY_INCOME:
        this.headers = this.ytdSummaryCompanyIncomeReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.VALUATION_ENGAGEMENT_CUSTOMER_DATA:
        this.headers = this.valuationsReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.VALUATION_SUMMARY_REPORTS:
        this.headers = this.valuationSummaryReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      case ReportsList.VALUATION_PROPERTY_CUSTOMER_DATA:
        this.headers = this.valuationPropertyCustomerReportService.getHeaders({
          'middle': this.middle, 'left': this.left, 'right': this.right
        });
        break;
      default:
        break;
    }
    this.headers.forEach((report: any) => {
      report.header = report.header.toString().toUpperCase();
    });
  }

  mapFeesplits(transactionSummaryData: any) {
    transactionSummaryData.results?.map((report: DataObject) => {
      report['account'] = report?.feesplit?.account;
      report['broker_emplid'] = report?.feesplit?.broker;
      report['company_office'] = report?.feesplit?.company_office;
      report['flat_amount'] = report?.feesplit?.flat_amount;
      report['disbursement_alloc_amt'] =
        report?.feesplit?.disbursement_alloc_amt;
      report['percent_output'] = report?.feesplit?.percent_output;
      report['project_description'] = report?.feesplit?.project;
      report['akol_ded'] = report?.feesplit?.akol_ded;
      report['smf_amount'] = report?.feesplit?.smf;
      report['greenspace'] = report?.feesplit?.greenspace ? 'Yes' : 'No';
      report['cbre_broker_actual_fee'] = report?.feesplit?.bill_external
        ? ''
        : report?.feesplit?.actual_fee;
      report['conjunctional_agent_actual_fee'] = report?.feesplit?.bill_external
        ? report?.feesplit?.actual_fee
        : '';
      report['external_broker'] = report?.feesplit?.external_broker
        ? 'Yes'
        : 'No';
    });
  }

  mapBrokerDetails(transactionSummaryData: any) {
    transactionSummaryData.results?.map((report: DataObject) => {
      report['broker_name'] = report?.feesplit?.broker_details[0]?.name;
      report['broker_functional_unit'] =
        report?.feesplit?.broker_details[0]?.functional_unit?.id;
      report['broker_functional_unit_description'] =
        report?.feesplit?.broker_details[0]?.functional_unit?.name;
      report['broker_managing_office'] =
        report?.feesplit?.broker_details[0]?.managing_office?.id;
      report['broker_managing_office_description'] =
        report?.feesplit?.broker_details[0]?.managing_office?.name;
    });
  }

  mapPropertyDetails(transactionSummaryData: any) {
    transactionSummaryData.results.map((report: DataObject) => {
      if (report?.property) {
        report['building_name'] = report?.property?.building_name;
        report['managed_by_cbre'] = report?.property?.managed_by_cbre;
        report['property_type'] = report?.property?.property_type;
        report['property_subtype'] = report?.property?.property_subtype;
        report['address_line1'] = report?.property?.address_line1;
        report['address_line2'] = report?.property?.address_line2;
        report['postal_code'] = report?.property?.postal_code;
        report['locality'] = report?.property?.locality;
        report['region'] = report?.property?.region;
        report['country'] = report?.property?.country;
      } else {
        return report;
      }
    });
  }

  mapSpaceTypeDetails(transactionSummaryData: any) {
    transactionSummaryData.results.map((report: DataObject) => {
      if (report?.spacetypes) {
        report['property_type_space'] = report?.spacetypes?.property_type_space_label;
        report['space_condition'] = report?.spacetypes?.space_condition;
        report['desks'] = report?.spacetypes?.desks;
        report['racks'] = report?.spacetypes?.racks;
        report['servers'] = report?.spacetypes?.servers;
        report['megawatts'] = report?.spacetypes?.megawatts;
        report['kilowatts'] = report?.spacetypes?.kilowatts;
        report['floor'] = report?.spacetypes?.floor;
        report['suite'] = report?.spacetypes?.suite;
        [report['size'], report['size_measurement']] = this.getSpaceTypeSize(report?.property_type, report?.spacetypes);
      } else {

        const spaceType = {
          'property_type_space': report?.property_type_space_label,
          'size': report?.size,
          'size_measurement': report?.size_measurement,
          'land': report?.land,
          'land_measurement': report?.land_measurement,
          'rooms': report?.rooms,
          'units': report?.units,
        };

        [report['size'], report['size_measurement']] = this.getSpaceTypeSize(report?.property_type, spaceType);
        return report;
      }
    });
  }

  getSpaceTypeSize(propertyType: string, spaceTypes: any): any {
    let size = 0;
    let size_measurement = 'SQF';
    let spaceTypesToGetSize = [];

    if (spaceTypes.length) {
      spaceTypesToGetSize = spaceTypes;
    } else {
      spaceTypesToGetSize[0] = spaceTypes;
    }

    const sizeBySpaceType = this.reportingService.getPropertySizeBySpaceType(propertyType, spaceTypesToGetSize);

    if (sizeBySpaceType) {
      ['size', 'units', 'rooms', 'land'].forEach((size_type) => {
        if (sizeBySpaceType[size_type]) {
          size = sizeBySpaceType[size_type];
          switch (size_type) {
            case 'land':
              size_measurement = spaceTypes.land_measurement;
              break;
            case 'size':
              size_measurement = spaceTypes.size_measurement;
              break;
            case 'rooms':
            case 'units':
              size_measurement = size_type;
              break;
          }
        }
      });
    }

    return [size, size_measurement];
  }

  mapBillToCustomer(transactionSummaryData: any) {
    transactionSummaryData.results.map((report: any) => {
      if (report?.bill_to_third_party) {
        report['bill_to_cust'] = report?.bill_to_party || '';
      } else {
        report['bill_to_cust'] = report?.represented_party || '';
      }
    });
  }

  // Maps YTD numeric fields to number
  mapYtdNumericFields(data: any) {
    const numericFields = [
      'producer_percent',
      'cbre_broker_actual_fee',
      'disbursement_amount',
      'smf',
      'deduction',
      'conjunctional_agent_actual_fee',
      'sale_lease_value',
      'cbre_fee_total',
      'cbre_revenue_fumo_balance',
    ];
    return data.map((report: any) => {
      numericFields.forEach((field) => {
        if (report[field]) {
          report[field] = +(report[field]);
        }
      });
      return report;
    });
  }

}
